import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { normalizeContainsEitherOfValues } from '../../../shared/constant';

@Component({
  selector: 'either-of-input',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './either-of-input.component.html',
  styleUrl: './either-of-input.component.scss',
})
export class EitherOfInputComponent {
  @Input() values: string[] = [];
  @Input() placeholderText = 'Enter Value';
  @Output() valuesChange = new EventEmitter<string[]>();

  draft = '';

  addFromDraft(): void {
    const next = normalizeContainsEitherOfValues([...this.values, this.draft]);
    this.draft = '';
    if (next.length === this.values.length && next.every((value, i) => value === this.values[i])) {
      return;
    }
    this.valuesChange.emit(next);
  }

  handleKeydown(event: KeyboardEvent): void {
    event.stopPropagation();
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      this.addFromDraft();
    } else if (event.key === 'Backspace' && !this.draft && this.values.length) {
      event.preventDefault();
      this.removeValue(this.values[this.values.length - 1]);
    }
  }

  handlePaste(event: ClipboardEvent): void {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (!/[,|\n]/.test(pasted)) {
      return;
    }
    event.preventDefault();
    const next = normalizeContainsEitherOfValues([...this.values, this.draft, pasted]);
    this.draft = '';
    this.valuesChange.emit(next);
  }

  handleBlur(): void {
    if (this.draft.trim()) {
      this.addFromDraft();
    }
  }

  removeValue(value: string): void {
    this.valuesChange.emit(this.values.filter((item) => item !== value));
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }
}
